import React, { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import useToken from '../../hooks/useToken';
import axios from 'axios';
import { jwtDecode as jwt_decode } from 'jwt-decode';
import MovieCard from '../../components/MovieCard/MovieCard';
import './ProfilePage.css';
import { APIURLContext } from '../../contexts/APIURLContext';


export default function ProfilePage() {
    const { token, setToken } = useToken();
    const [user, setUser] = useState(null);
    const [viewMode, setViewMode] = useState('watchlist'); // Default to 'watchlist'
    const [watchlist, setWatchlist] = useState([]);
    const [loading, setLoading] = useState(true);
    const apiUrl = useContext(APIURLContext);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                // Retrieve the access token from local storage
                const accessToken = localStorage.getItem('accessToken');

                // Decode the access token to extract payload
                const decodedToken = jwt_decode(accessToken);

                // Extract email, first name, and last name from the decoded payload
                const { name, username } = decodedToken;

                // Set the email, first name, and last name in the state
                setUser({ firstName: name.first, lastName: name.last, username });

                // Fetch user's watchlist IDs
                const response = await axios.get(`${apiUrl}/watchlist/${decodedToken._id}`);
                const movieIds = response.data.movies;

                // Fetch details of each movie in the watchlist
                const movieDetailsPromises = movieIds.map(async (movieId) => {
                    const movieResponse = await axios.get(`${apiUrl}/movies/${movieId}`);
                    return movieResponse.data;
                });

                // Wait for all API calls to complete
                const movieDetails = await Promise.all(movieDetailsPromises);
                setWatchlist(movieDetails);
            } catch (error) {
                console.error('Error fetching user profile:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserProfile();
    }, [apiUrl]);

    // If there isn't a token set, redirect the user to the login page
    if (!token) {
        return <Navigate to='/login' replace />;
    }

    // Handler function for logout
    const handleLogout = () => {
        // Clear authentication token
        setToken(null);
    };

    const handleViewModeChange = (mode) => {
        setViewMode(mode);
    };
    return (
        <div className='container'>
        <div className="profile-container">
            {user && (
                <div>
                    <h1>Welcome back, {user.firstName}.</h1>
                    <div className="options-container">
                        <button
                            onClick={() => handleViewModeChange('watchlist')}
                            className={viewMode === 'watchlist' ? 'active' : ''}
                        >
                            View Your Watchlist
                        </button>
                        <button
                            onClick={() => handleViewModeChange('account')}
                            className={viewMode === 'account' ? 'active' : ''}
                        >
                            View Account Information
                        </button>
                        <button className = "logout-button" onClick={handleLogout}>Logout</button>
                    </div>
                    
                  
                    {viewMode === 'watchlist' && (
                        <div>
                            <h2>Your Watchlist</h2>
                            {loading ? (
                                <p>Loading...</p>
                            ) : watchlist.length === 0 ? (
                                <p>Your watchlist is empty.</p>
                            ) : (
                                <div className="card-deck">
                                    <div className="d-flex flex-wrap justify-content-center">
                                        {watchlist.map((movie) => (
                                            <div className="col" key={movie._id}>
                                                <MovieCard
                                                    movie={movie} // Pass the movie object as a prop
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {viewMode === 'account' && (
                        <div className="account-info">
                            <h2>Account Information</h2>
                            <p><strong>Username</strong> - {user.username}</p>
                            <p><strong>First Name</strong> - {user.firstName}</p>
                            <p><strong>Last Name</strong> - {user.lastName}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
        </div>
    );
}
